import { render, staticRenderFns } from "./ScheduleConfig.vue?vue&type=template&id=36607e28"
import script from "./ScheduleConfig.vue?vue&type=script&lang=js"
export * from "./ScheduleConfig.vue?vue&type=script&lang=js"
import style0 from "./ScheduleConfig.vue?vue&type=style&index=0&id=36607e28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports